import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import LandingPage from './Pages/LandingPage';
import Login from './Pages/Login';
import PartnerApplication from './Pages/PartnerApplication';
import ConfirmPassword from './Pages/ConfirmPassword';
import ForgotPassword from './Pages/ForgotPassword';
import Outer from './Layouts/Outer';
import HomePageProductPage from './Pages/HomePageProductPage';
import ProductCardPage from './Pages/ProductCardPage';
import MyProfile from './Pages/UserDetails/MyProfile';
import ChangePassword from './Pages/UserDetails/ChangePassword';
import UserMaster from './Pages/UserMaster/UserMaster';
import ServiceProviderMaster from './Pages/ServiceProvider/ServiceProviderMaster';
import NotificationList from './Pages/Notifications/NotificationList';
import Dashboard from './Pages/Dashboard/Dashboard';
import AddServiceProvider from './Pages/ServiceProvider/AddServiceProvider';
import AddStartUp from './Pages/UserMaster/AddStartUp';
import EditStartUp from './Pages/UserMaster/EditStartUp';
import EditServiceProvider from './Pages/ServiceProvider/EditServiceProvider';
import ForgotPasswordOTPInput from './Pages/forgotPasswordOTPInput';
import NotFound from './Pages/NotFound';
import CategoriesList from './Pages/Categories/CategoriesList';
import AddCategory from './Pages/Categories/AddCategory';
import EditCategory from './Pages/Categories/EditCategory';
import Startup from './Layouts/Startup';
import Admin from './Layouts/Admin';
import PlanList from './Pages/Plans/PlanList';
import AddPlan from './Pages/Plans/AddPlan';
import EditPlan from './Pages/Plans/EditPlan';
import AddNotification from './Pages/Notifications/AddNotification';
import EditNotification from './Pages/Notifications/EditNotification';
// eslint-disable-next-line
import EmailContentList from './Pages/EmailContent/EmailContentList';
import Explore from './Pages/Explore';
import RequestStartup from './Pages/RequestStartUp/RequestStartup';
import RequestStartUpList from './Pages/RequestStartUp/RequestStartUpList';
import UpdateStartUpRequest from './Pages/RequestStartUp/UpdateStartUpRequest';
import DataRepositoryList from './Pages/Data Repository/DataRepositoryList';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Outer />}>
          <Route path="/" element={<LandingPage />} />
          <Route exact path="login" element={<Login />} />
          <Route exact path="partner-application" element={<PartnerApplication />} />
          <Route exact path="forgot-password" element={<ForgotPassword />} />
          <Route exact path="verify-reset-password/:token" element={<ForgotPasswordOTPInput />} />
          <Route exact path="confirm-password" element={<ConfirmPassword />} />
          <Route exact path="explore" element={<Explore />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route element={<Startup />}>
          <Route exact path="/category/:keyword/:id" element={<HomePageProductPage />} />
          <Route exact path="/service-provider/:id/:serviceproviderid" element={<ProductCardPage />} />
          <Route exact path="/my-profile" element={<MyProfile />} />
          <Route exact path="/startup/change-password" element={<ChangePassword />} />
          <Route exact path="/request-support" element={<RequestStartup />} />
        </Route>
        <Route element={<Admin />}>
          <Route exact path="/my-profile" element={<MyProfile />} />
          <Route exact path="/admin/change-password" element={<ChangePassword />} />
          <Route exact path="/startups" element={<UserMaster />} />
          <Route exact path="/service-provider-master" element={<ServiceProviderMaster />} />
          <Route exact path="/mis" element={<Dashboard />} />
          <Route exact path="/add-service-provider" element={<AddServiceProvider />} />
          <Route exact path="/edit-service-provider/:id" element={<EditServiceProvider />} />
          <Route exact path="/add-startups" element={<AddStartUp />} />
          <Route exact path="/edit-startups/:id" element={<EditStartUp />} />
          <Route exact path="/categories" element={<CategoriesList />} />
          <Route exact path="/categories/add-category" element={<AddCategory />} />
          <Route exact path="/categories/edit-category/:id" element={<EditCategory />} />
          <Route exact path="/plans" element={<PlanList />} />
          <Route exact path="/add-plan" element={<AddPlan />} />
          <Route exact path="/edit-plan/:id" element={<EditPlan />} />
          <Route exact path="/notifications" element={<NotificationList />} />
          <Route exact path="/add-notification" element={<AddNotification />} />
          <Route exact path="/edit-notification/:id" element={<EditNotification />} />
          <Route exact path="/email-contents" element={<EmailContentList />} />
          <Route exact path="/support-list" element={<RequestStartUpList />} />
          <Route exact path="/support-edit/:id" element={<UpdateStartUpRequest />} />
          <Route exact path="/data-repository" element={<DataRepositoryList />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
